// src/utils/aufHandoffStore.js
// Minimal, in-memory singleton for Flow 3 file handoff.
// It never persists to storage, so Files/Blobs are memory-only.
let pending = null; // { file: File } | null

export function setAufPendingFile(file) {
  if (file && file instanceof File) {
    pending = { file };
  } else {
    pending = null;
  }
}

export function consumeAufPendingFile() {
  const out = pending;
  pending = null;
  return out; // { file } or null
}
